import { createSelector } from 'reselect'
import createVisitorsSelector from '../selectors/createVisitorsSelector'
import { currentUserSelector } from 'selectors/currentUser'

export const getId = (state, props) => props.cardContext.id

export const getIsLoaded = (state, props) => {
  return state['view-card'].activities[props.cardContext.id].isLoaded
}

export const getIsLoading = (state, props) => {
  return state['view-card'].activities[props.cardContext.id].isLoading
}

export const getLastLoadedId = (state, props) => {
  return state['view-card'].activities[props.cardContext.id].lastLoadedId
}

export const getActivitiesDetailLevel = (state, props) => {
  return state.kanbo.currentUser.settings.activitiesDetailLevel
}

const getActivities = (state, props) => {
  return state['view-card'].activities[props.cardContext.id].activities
}

const getActivitiesById = (state, props) => {
  return state['view-card'].activities[props.cardContext.id].activitiesById
}

const createActivitiesSelector = () => createSelector(
  [getActivities, getActivitiesById],
  (activities, activitiesById) =>
    activities.map(id => activitiesById[id])
)

const createFilteredVisitorsSelector = (visitorsSelector) => createSelector(
  [visitorsSelector, currentUserSelector],
  (visitors, currentUser) =>
    visitors.filter(visitor => visitor.id !== currentUser.id)
)

export default () => {
  const activitiesSelector = createActivitiesSelector()
  const visitorsSelector = createVisitorsSelector(getId)
  const filteredVisitorsSelector = createFilteredVisitorsSelector(visitorsSelector)

  return createSelector(
    [
      getId,
      getIsLoaded,
      getIsLoading,
      getLastLoadedId,
      currentUserSelector,
      activitiesSelector,
      getActivitiesDetailLevel,
      filteredVisitorsSelector,
    ],
    (
      id,
      isLoaded,
      isLoading,
      lastLoadedId,
      currentUser,
      activities,
      activitiesDetailLevel,
      visitors,
    ) => ({
      context: 'card-' + id,
      isLoaded,
      isLoading,
      lastLoadedId,
      currentUser,
      activities,
      activitiesDetailLevel,
      visitors
    })
  )
}
